import styled from "styled-components";

export const MobileSortContainer = styled.div`
  li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem;
    box-shadow: 1px 1px 5px 0 rgba(79, 104, 145, 0.05);
    -webkit-box-shadow: 1px 1px 5px 0 rgba(79, 104, 145, 0.05);
    -moz-box-shadow: 1px 1px 5px 0 rgba(79, 104, 145, 0.05);

    & > div {
      p {
        font-size: .95rem;
      }

      p:last-child {
        font-size: .8rem;
      }
    }
  }

  i.arrow {
    display: inline-block;
    transform: rotateZ(90deg);

    &::before {
      font-size: .4rem;
    }
  }
`;
